import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { EMPTY_STRING, termsAndConditionsConstants } from "../../constants";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import convertContentToHTML from "../../shared/utility-functions/ConvertContentToHtml";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { termsAndConditionsActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";

const { GET_TERMS_AND_CONDITIONS, ADD_OR_UPDATE_TERMS_AND_CONDITIONS } =
  termsAndConditionsConstants;

const TermsAndConditions = (props) => {
  const { getTermsAndConditions, termsAndConditions, spinnerActions } = props;

  const [htmlContent, setHtmlContent] = useState(EMPTY_STRING);

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  useEffect(() => {
    if (termsAndConditions?.content) {
      const html = convertContentToHTML(termsAndConditions.content);
      setHtmlContent(html);
    }
  }, [termsAndConditions]);

  useEffect(() => {
    getTermsAndConditions();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Topbar />
      {(spinner(GET_TERMS_AND_CONDITIONS) > -1 ||
        spinner(ADD_OR_UPDATE_TERMS_AND_CONDITIONS)) > -1 && <MainSpinner />}
      <MainContentWrapper>
        <div className="container">
          <div className="about-us-heading">Terms and Conditions</div>
          {spinner(GET_TERMS_AND_CONDITIONS) === -1 && (
            <div
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              className="mt-4"
            />
          )}
        </div>
      </MainContentWrapper>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  termsAndConditions: state.termsAndConditionsReducer.termsAndConditions,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  getTermsAndConditions: () =>
    dispatch(termsAndConditionsActions.getTermsAndConditions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);
